'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');
var reactResizable = require('react-resizable');
var jsxRuntime = require('react/jsx-runtime');

var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  __defProp(target, "default", { value: mod, enumerable: true }) ,
  mod
));

// node_modules/.pnpm/lodash.debounce@4.0.8/node_modules/lodash.debounce/index.js
var require_lodash = __commonJS({
  "node_modules/.pnpm/lodash.debounce@4.0.8/node_modules/lodash.debounce/index.js"(exports, module) {
    var FUNC_ERROR_TEXT = "Expected a function";
    var NAN = 0 / 0;
    var symbolTag = "[object Symbol]";
    var reTrim = /^\s+|\s+$/g;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsOctal = /^0o[0-7]+$/i;
    var freeParseInt = parseInt;
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    var objectProto = Object.prototype;
    var objectToString = objectProto.toString;
    var nativeMax = Math.max;
    var nativeMin = Math.min;
    var now = function() {
      return root.Date.now();
    };
    function debounce2(func, wait, options) {
      var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject2(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
      }
      function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = void 0;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }
      function leadingEdge(time) {
        lastInvokeTime = time;
        timerId = setTimeout(timerExpired, wait);
        return leading ? invokeFunc(time) : result;
      }
      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result2 = wait - timeSinceLastCall;
        return maxing ? nativeMin(result2, maxWait - timeSinceLastInvoke) : result2;
      }
      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
      }
      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        timerId = setTimeout(timerExpired, remainingWait(time));
      }
      function trailingEdge(time) {
        timerId = void 0;
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = void 0;
        return result;
      }
      function cancel() {
        if (timerId !== void 0) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = void 0;
      }
      function flush() {
        return timerId === void 0 ? result : trailingEdge(now());
      }
      function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
          if (timerId === void 0) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === void 0) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }
    function isObject2(value) {
      var type = typeof value;
      return !!value && (type == "object" || type == "function");
    }
    function isObjectLike(value) {
      return !!value && typeof value == "object";
    }
    function isSymbol(value) {
      return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
    }
    function toNumber(value) {
      if (typeof value == "number") {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject2(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = isObject2(other) ? other + "" : other;
      }
      if (typeof value != "string") {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, "");
      var isBinary = reIsBinary.test(value);
      return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
    }
    module.exports = debounce2;
  }
});

// src/hooks/useDebounceFn.ts
var import_lodash = __toESM(require_lodash());
function useCreation(factory, deps) {
  const { current } = react.useRef({
    deps,
    obj: void 0,
    initialized: false
  });
  if (current.initialized === false || !depsAreSame(current.deps, deps)) {
    current.deps = deps;
    current.obj = factory();
    current.initialized = true;
  }
  return current.obj;
}
function depsAreSame(oldDeps, deps) {
  if (oldDeps === deps) return true;
  for (let i = 0; i < oldDeps.length; i++) {
    if (oldDeps[i] !== deps[i]) return false;
  }
  return true;
}

// src/hooks/useDebounceFn.ts
function useDebounceFn(fn, options) {
  var _a;
  const fnRef = react.useRef(fn);
  fnRef.current = fn;
  const wait = (_a = options == null ? void 0 : options.wait) != null ? _a : 1e3;
  const debounced = useCreation(
    () => (0, import_lodash.default)(
      (...args) => {
        return fnRef.current(...args);
      },
      wait,
      options
    ),
    []
  );
  react.useEffect(() => {
    debounced.cancel();
  }, []);
  return {
    run: debounced,
    cancel: debounced.cancel,
    flush: debounced.flush
  };
}

// src/utils/index.ts
function depthFirstSearchWidthSet(children, condition, width) {
  const c = [...children];
  (function find(cls) {
    if (!cls) return;
    for (let i = 0; i < (cls == null ? void 0 : cls.length); i++) {
      if (condition(cls[i])) {
        cls[i] = __spreadProps(__spreadValues({}, cls[i]), {
          width
        });
        return;
      }
      if (cls[i].children) {
        find(cls[i].children);
      }
    }
  })(c);
  return c;
}
function isString(data) {
  return typeof data === "string";
}
function isUndefined(data) {
  return typeof data === "undefined";
}
function isNumber(data) {
  return typeof data === "number";
}
function isObject(data) {
  return Object.prototype.toString.call(data) === "[object Object]";
}
function isEmpty(data) {
  if (typeof data !== "object" || data === null) {
    return true;
  }
  if (Array.isArray(data) && data.length) {
    return false;
  }
  if (Object.keys(data).length) {
    return false;
  }
  return true;
}
function isColHidden(col) {
  return col.hideInTable || col.hidden;
}
function isReservedColumn(item) {
  return item && isObject(item) && Object.keys(item).length === 0;
}

// src/hooks/useGetDataIndexColumns.ts
var GETKEY = "dataIndex";
var ResizableUniqIdPrefix = "resizable-col-id";
function getUniqueId(s) {
  return `${ResizableUniqIdPrefix}-${s}`;
}
function getColumns(list) {
  const trulyColumns = list == null ? void 0 : list.filter((item) => !isEmpty(item) || isReservedColumn(item));
  const c = trulyColumns == null ? void 0 : trulyColumns.map((col, index) => {
    var _a;
    if (isReservedColumn(col)) {
      return col;
    }
    return __spreadProps(__spreadValues({}, col), {
      children: ((_a = col == null ? void 0 : col.children) == null ? void 0 : _a.length) ? getColumns(col.children) : void 0,
      [GETKEY]: col[GETKEY] || col.key || getUniqueId(`${col.title}-${index}`)
    });
  });
  return c;
}
function useGetDataIndexColumns(columns) {
  const dataIndexColumns = react.useMemo(() => getColumns(columns), [columns]);
  return dataIndexColumns || columns;
}
var isBrowser = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var useIsomorphicLayoutEffect = isBrowser ? react.useLayoutEffect : react.useEffect;
function useLatest(value) {
  const ref = react.useRef(value);
  ref.current = value;
  return ref;
}
function useMemoizedFn(fn) {
  {
    if (typeof fn !== "function") {
      console.error(`useMemoizedFn expected parameter is a function, got ${typeof fn}`);
    }
  }
  const fnRef = react.useRef(fn);
  fnRef.current = react.useMemo(() => fn, [fn]);
  const memoizedFn = react.useRef();
  if (!memoizedFn.current) {
    memoizedFn.current = function(...args) {
      return fnRef.current.apply(this, args);
    };
  }
  return memoizedFn.current;
}

// src/hooks/useLocalColumns.ts
function mergeColumns(src, target, mergeKey) {
  const res = src;
  if (Array.isArray(res) && Array.isArray(target)) {
    res.forEach((t, i) => {
      var _a, _b;
      if (t == null ? void 0 : t.children) {
        mergeColumns(t.children, (_a = target[i]) == null ? void 0 : _a.children, mergeKey);
      } else {
        res[i][mergeKey] = ((_b = target.find((x) => {
          const targetDataIndex = Array.isArray(x.dataIndex) ? x.dataIndex.join("-") : x.dataIndex;
          const resDataIndex = Array.isArray(res[i].dataIndex) ? res[i].dataIndex.join("-") : res[i].dataIndex;
          return targetDataIndex === resDataIndex;
        })) == null ? void 0 : _b[mergeKey]) || res[i][mergeKey];
        if (res[i][mergeKey] === void 0) {
          delete res[i][mergeKey];
        }
      }
    });
  }
  return res;
}
function useLocalColumns({
  columnsState,
  resizableColumns,
  columns
}) {
  const columnsProp = useGetDataIndexColumns(columns);
  const initLocalColumns = useMemoizedFn(() => {
    var _a;
    const { persistenceType, persistenceKey } = columnsState || {};
    if (!persistenceKey || !persistenceType) {
      return columnsProp;
    }
    if (typeof window === "undefined") return columnsProp;
    const storage = window[persistenceType];
    try {
      const localResizableColumns = (_a = JSON.parse((storage == null ? void 0 : storage.getItem(persistenceKey)) || "{}")) == null ? void 0 : _a.resizableColumns;
      return mergeColumns(columnsProp || [], localResizableColumns, "width");
    } catch (error) {
      console.error(error);
    }
  });
  const [localColumns, setLocalColumns] = react.useState(initLocalColumns);
  react.useEffect(() => {
    setLocalColumns(initLocalColumns());
  }, [columnsProp]);
  react.useEffect(() => {
    const { persistenceType, persistenceKey } = columnsState || {};
    if (!persistenceKey || !persistenceType || !(resizableColumns == null ? void 0 : resizableColumns.length)) {
      return;
    }
    if (typeof window === "undefined") return;
    const storage = window[persistenceType];
    try {
      storage.setItem(
        persistenceKey,
        JSON.stringify(__spreadProps(__spreadValues({}, JSON.parse((storage == null ? void 0 : storage.getItem(persistenceKey)) || "{}")), {
          resizableColumns: resizableColumns.map((col) => {
            const localCol = {
              dataIndex: col.dataIndex,
              key: col.key,
              width: col.width,
              children: col.children
            };
            if (isString(col.title)) {
              localCol.title = col.title;
            }
            return localCol;
          })
        }))
      );
    } catch (error) {
      console.error(error);
    }
  }, [resizableColumns]);
  const resetLocalColumns = useMemoizedFn((resetStorage = true) => {
    setLocalColumns([...(resetStorage ? columns : columnsProp) || []]);
  });
  return {
    localColumns: react.useMemo(() => localColumns, [localColumns]),
    resetLocalColumns
  };
}
var useUnmountedRef = () => {
  const unmountedRef = react.useRef(false);
  react.useEffect(() => {
    unmountedRef.current = false;
    return () => {
      unmountedRef.current = true;
    };
  }, []);
  return unmountedRef;
};

// src/hooks/useSafeState.ts
function useSafeState(initialState) {
  const unmountedRef = useUnmountedRef();
  const [state, setState] = react.useState(initialState);
  const setCurrentState = react.useCallback((currentState) => {
    if (unmountedRef.current) return;
    setState(currentState);
  }, []);
  return [state, setCurrentState];
}
var createUpdateEffect = (hook) => (effect, deps) => {
  const isMounted = react.useRef(false);
  hook(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);
  hook(() => {
    if (!isMounted.current) {
      isMounted.current = true;
    } else {
      return effect();
    }
  }, deps);
};

// src/hooks/useUpdateEffect.ts
var useUpdateEffect = createUpdateEffect(react.useEffect);

// src/utils/clsx.ts
function clsx(...args) {
  return args.filter(Boolean).join(" ");
}

// src/utils/constant.ts
var DefaultWidth = 120;
function resolveThWidthByColgroup(thElement) {
  var _a, _b;
  const tableElement = thElement.closest("table");
  if (tableElement) {
    const colgroup = tableElement.querySelector("colgroup");
    const cols = colgroup == null ? void 0 : colgroup.querySelectorAll("col");
    const rows = ((_a = tableElement.querySelector("thead")) == null ? void 0 : _a.rows) || [];
    const cellPositions = [];
    for (let i = 0; i < rows.length; i++) {
      const cells2 = rows[i].cells;
      let colIndex = 0;
      for (let j = 0; j < cells2.length; j++) {
        const cell = cells2[j];
        const rowspan = cell.rowSpan || 1;
        const colspan = cell.colSpan || 1;
        while (cellPositions[i] && cellPositions[i][colIndex]) {
          colIndex++;
        }
        for (let r = 0; r < rowspan; r++) {
          for (let c = 0; c < colspan; c++) {
            if (!cellPositions[i + r]) {
              cellPositions[i + r] = [];
            }
            cellPositions[i + r][colIndex + c] = cell;
          }
        }
        colIndex += colspan;
      }
    }
    const cells = cellPositions[cellPositions.length - 1];
    const colindex = cells.indexOf(thElement);
    if (colindex !== -1) {
      const colWidth = (_b = cols == null ? void 0 : cols[colindex]) == null ? void 0 : _b.clientWidth;
      if (isNumber(colWidth)) {
        return colWidth;
      }
    }
  }
}
function ResizableHeader(props) {
  const _a = props, {
    width,
    minWidth,
    maxWidth,
    resizable,
    hide,
    _onResizeEnd,
    onResizeStart,
    onResizeEnd,
    onColChange,
    shouldRender,
    className,
    style,
    onClick,
    children,
    rowSpan,
    colSpan,
    title,
    scope
  } = _a, rest = __objRest(_a, [
    "width",
    "minWidth",
    "maxWidth",
    "resizable",
    "hide",
    "_onResizeEnd",
    "onResizeStart",
    "onResizeEnd",
    "onColChange",
    "shouldRender",
    "className",
    "style",
    "onClick",
    "children",
    "rowSpan",
    "colSpan",
    "title",
    "scope"
  ]);
  const [resizeWidth, setResizeWidth] = useSafeState(0);
  const [colWidth, setColWidth] = useSafeState(0);
  const thRef = react.useRef(null);
  const onColWidthChanged = useMemoizedFn((callback) => {
    const fn = () => {
      if (thRef.current) {
        const colWidth2 = resolveThWidthByColgroup(thRef.current);
        if (colWidth2) {
          setColWidth(colWidth2);
          setResizeWidth(colWidth2);
          callback == null ? void 0 : callback(colWidth2);
        }
      }
    };
    if (window.requestIdleCallback) {
      window.requestIdleCallback(() => {
        fn();
      });
    } else {
      setTimeout(() => {
        fn();
      }, 1);
    }
  });
  react.useEffect(() => {
    if (width) {
      onColWidthChanged();
    }
  }, [width, shouldRender]);
  if (hide) {
    return null;
  }
  if (!width || Number.isNaN(Number(width)) || resizable === false) {
    return /* @__PURE__ */ jsxRuntime.jsx(
      "th",
      __spreadProps(__spreadValues({}, rest), {
        "data-resizable-col": "false",
        style,
        className,
        onClick,
        rowSpan,
        colSpan,
        ref: thRef,
        children: /* @__PURE__ */ jsxRuntime.jsx("span", { title, children })
      })
    );
  }
  const setBodyStyle = (active) => {
    document.body.style.userSelect = active ? "none" : "";
    document.body.style.pointerEvents = active ? "none" : "";
    document.documentElement.style.cursor = active ? "col-resize" : "";
  };
  const onStart = ({}, data) => {
    if (resizeWidth >= maxWidth || resizeWidth <= minWidth) return;
    setResizeWidth(data.size.width);
    onResizeStart == null ? void 0 : onResizeStart(data.size.width);
  };
  const onSelfResize = ({}, data) => {
    setBodyStyle(true);
    setResizeWidth(data.size.width);
  };
  const onStop = () => {
    setBodyStyle(false);
    if (resizeWidth <= 0) return;
    let w = resizeWidth;
    if (w >= maxWidth) {
      w = maxWidth > width ? maxWidth : width;
    } else if (w <= minWidth) {
      w = minWidth < width ? minWidth : width;
    }
    _onResizeEnd(w);
    onResizeEnd == null ? void 0 : onResizeEnd(w);
    onColWidthChanged();
  };
  const isSimpleChildren = () => {
    var _a2, _b;
    if (Array.isArray(children)) {
      const lastChild = children[children.length - 1];
      if (lastChild) {
        return isString(lastChild) || ((_a2 = lastChild.props) == null ? void 0 : _a2.ellipsis) || isString((_b = lastChild.props) == null ? void 0 : _b.label);
      }
    }
    return false;
  };
  return /* @__PURE__ */ jsxRuntime.jsxs(
    "th",
    {
      ref: thRef,
      scope,
      className: clsx("antd-resizable-header" /* CSS */, className),
      style: __spreadProps(__spreadValues({}, style), {
        overflow: "unset"
      }),
      "data-resizable-col": "true",
      onClick,
      rowSpan,
      colSpan,
      children: [
        /* @__PURE__ */ jsxRuntime.jsx(
          reactResizable.Resizable,
          {
            className: `${"antd-resizable-header" /* CSS */}__content`,
            width: resizeWidth,
            minConstraints: [Math.min(minWidth, colWidth), 0],
            maxConstraints: [Math.max(maxWidth, colWidth), 0],
            height: 0,
            handle: /* @__PURE__ */ jsxRuntime.jsx(
              "div",
              {
                className: `${"antd-resizable-header" /* CSS */}__handler`,
                onClick: (e) => {
                  e.stopPropagation();
                },
                children: /* @__PURE__ */ jsxRuntime.jsx("div", { className: `${"antd-resizable-header" /* CSS */}__handler__line` })
              }
            ),
            draggableOpts: { enableUserSelectHack: false },
            onResizeStart: onStart,
            onResize: onSelfResize,
            onResizeStop: onStop,
            children: /* @__PURE__ */ jsxRuntime.jsx("div", { style: { width: resizeWidth, height: "100%" } })
          }
        ),
        /* @__PURE__ */ jsxRuntime.jsx("div", __spreadProps(__spreadValues({}, rest), { className: `${"antd-resizable-header" /* CSS */}__title${isSimpleChildren() ? "--ellipsis" : ""}`, children }))
      ]
    }
  );
}
var ResizableHeader_default = react.memo(ResizableHeader);

// src/utils/logger.ts
var errorMsgs = /* @__PURE__ */ new Set();
var logger = {
  errorOnce(msg) {
    if (!errorMsgs.has(msg)) {
      errorMsgs.add(msg);
      console.error(msg);
    }
  }
};

// src/utils/validateOptions.ts
function traverseColumnsWidth(cols) {
  if (!cols || !cols.length) return false;
  return cols.every((col) => {
    if (col.children && col.children.length) {
      return traverseColumnsWidth(col.children);
    }
    return !!col.width || isColHidden(col);
  });
}
function validateColumnsFlex(cols) {
  if (traverseColumnsWidth(cols) && true) {
    logger.errorOnce("[use-antd-resizable-header] \u8BF7\u4E0D\u8981\u5728\u6240\u6709\u5217\u4E0A\u6DFB\u52A0 `width` \u5C5E\u6027\uFF0C\u8FD9\u5C06\u5BFC\u81F4\u8868\u683C\u65E0\u6CD5\u81EA\u9002\u5E94");
    return false;
  }
}
function traverseColumnsDataIndex(cols, dataIndexMap = /* @__PURE__ */ new Map()) {
  if (!cols || !cols.length) return false;
  return cols.every((col) => {
    if (col.children && col.children.length) {
      return traverseColumnsDataIndex(col.children, dataIndexMap);
    }
    if (col.dataIndex) {
      if (dataIndexMap.has(col.dataIndex)) {
        {
          logger.errorOnce(
            `[use-antd-resizable-header] dataIndex \u91CD\u590D: ${col.dataIndex}\uFF0C\u8BF7\u786E\u4FDD\u6BCF\u4E2A\u5217\u7684 [dataIndex] \u552F\u4E00`
          );
        }
        return false;
      }
      dataIndexMap.set(col.dataIndex, true);
    }
    return true;
  });
}
function validateColumnsDataIndex(cols) {
  traverseColumnsDataIndex(cols, /* @__PURE__ */ new Map());
}
function validateColumns(cols) {
  validateColumnsFlex(cols);
  validateColumnsDataIndex(cols);
}

// src/useAntdResizableHeader.tsx
function useAntdResizableHeader(props) {
  const {
    columns: columnsProp,
    defaultWidth = DefaultWidth,
    minConstraints = defaultWidth / 2,
    maxConstraints = Number.POSITIVE_INFINITY,
    columnsState,
    onResizeStart: onResizeStartProp,
    onResizeEnd: onResizeEndProp,
    debounceWaitTime = 1e3
  } = props;
  validateColumns(columnsProp);
  const widthCache = react.useRef(/* @__PURE__ */ new Map());
  const [resizableColumns, setResizableColumns] = useSafeState(columnsProp || []);
  const latestColumns = useLatest(resizableColumns);
  const { localColumns, resetLocalColumns } = useLocalColumns({
    columnsState,
    columns: columnsProp,
    resizableColumns
  });
  const [tableWidth, setTableWidth] = useSafeState();
  const [shouldRender, forceRender] = react.useReducer((s) => s + 1, 0);
  const resetColumns = useMemoizedFn((resetStorage = true) => {
    widthCache.current.clear();
    resetLocalColumns(resetStorage);
  });
  const _onResizeEnd = useMemoizedFn((id) => (width) => {
    if (width) {
      const kvMap = /* @__PURE__ */ new Map();
      setResizableColumns((t) => {
        const nextColumns = depthFirstSearchWidthSet(
          t,
          (col) => col[GETKEY] === id && !!col.width && !isColHidden(col),
          width
        );
        function dig(cols) {
          var _a;
          for (let i = 0; i < cols.length; i++) {
            const col = cols[i];
            if (isColHidden(col)) continue;
            const key = col[GETKEY];
            kvMap.set((_a = String(key)) != null ? _a : "", { width: col == null ? void 0 : col.width, index: i });
            if (col == null ? void 0 : col.children) {
              dig(col.children);
            }
          }
        }
        dig(nextColumns);
        widthCache.current = kvMap;
        return nextColumns;
      });
    }
  });
  const onResizeStart = useMemoizedFn((col) => (width) => {
    onResizeStartProp == null ? void 0 : onResizeStartProp(__spreadProps(__spreadValues({}, col), {
      width,
      resizableColumns: latestColumns.current
    }));
  });
  const onResizeEnd = useMemoizedFn((col) => (width) => {
    onResizeEndProp == null ? void 0 : onResizeEndProp(__spreadProps(__spreadValues({}, col), {
      width,
      resizableColumns: latestColumns.current
    }));
    forceRender();
  });
  const getColumns2 = useMemoizedFn((list) => {
    const trulyColumns = list == null ? void 0 : list.filter((item) => !isEmpty(item) || isReservedColumn(item));
    const c = trulyColumns.map((col) => {
      var _a, _b, _c, _d;
      if (isReservedColumn(col)) {
        return col;
      }
      return __spreadProps(__spreadValues({}, col), {
        children: ((_a = col == null ? void 0 : col.children) == null ? void 0 : _a.length) ? getColumns2(col.children) : void 0,
        onHeaderCell: (column) => {
          var _a2, _b2, _c2, _d2;
          return __spreadProps(__spreadValues({}, (_a2 = col.onHeaderCell) == null ? void 0 : _a2.call(col, column)), {
            "data-index": column.dataIndex,
            "title": isString(column == null ? void 0 : column.title) ? column == null ? void 0 : column.title : "",
            "width": ((_d2 = (_c2 = widthCache.current) == null ? void 0 : _c2.get((_b2 = column[GETKEY]) != null ? _b2 : "")) == null ? void 0 : _d2.width) || (column == null ? void 0 : column.width),
            "resizable": column.resizable,
            "_onResizeEnd": _onResizeEnd(column == null ? void 0 : column[GETKEY]),
            "onResizeStart": onResizeStart(column),
            "onResizeEnd": onResizeEnd(column),
            "minWidth": column.minConstraints || minConstraints,
            "maxWidth": column.maxConstraints || maxConstraints,
            "hide": isColHidden(column),
            shouldRender
          });
        },
        // ellipsis为true时，表格布局将变成 tableLayout="fixed"
        ellipsis: isUndefined(col.ellipsis) ? true : col.ellipsis,
        width: ((_d = (_c = widthCache.current) == null ? void 0 : _c.get((_b = col[GETKEY]) != null ? _b : "")) == null ? void 0 : _d.width) || (col == null ? void 0 : col.width),
        [GETKEY]: col[GETKEY] || col.key
      });
    });
    return c;
  });
  useIsomorphicLayoutEffect(() => {
    if (localColumns) {
      const c = getColumns2(localColumns);
      setResizableColumns(c);
    }
  }, [localColumns]);
  useUpdateEffect(() => {
    const t = getColumns2(resizableColumns);
    setResizableColumns(t);
  }, [shouldRender]);
  useIsomorphicLayoutEffect(() => {
    let width = 0;
    (function loop(cls) {
      for (let i = 0; i < cls.length; i++) {
        if (cls[i].children) {
          loop(cls[i].children);
        } else if (!isColHidden(cls[i])) {
          width += Number(cls[i].width) || cls[i].defaultWidth || defaultWidth;
        }
      }
    })(resizableColumns);
    setTableWidth(width);
  }, [defaultWidth, resizableColumns]);
  const { run: debounceRender } = useDebounceFn(forceRender, {
    wait: debounceWaitTime
  });
  useIsomorphicLayoutEffect(() => {
    window.addEventListener("resize", debounceRender);
    return () => {
      window.removeEventListener("resize", debounceRender);
    };
  }, []);
  const components = react.useMemo(
    () => ({
      header: {
        cell: ResizableHeader_default
      }
    }),
    []
  );
  return {
    resizableColumns,
    components,
    tableWidth,
    resetColumns,
    refresh: forceRender
  };
}

// src/index.ts
var src_default = useAntdResizableHeader;

exports.ResizableUniqIdPrefix = ResizableUniqIdPrefix;
exports.default = src_default;
exports.useAntdResizableHeader = useAntdResizableHeader;
